import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaGlobeAmericas } from "react-icons/fa";

export default function Terms() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="max-w-4xl w-full mx-auto p-6 bg-white rounded-xl shadow-lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-lg relative"
        >
          <Link
            to="/"
            className="absolute -top-10 left-0 text-yellow-500 hover:text-yellow-600 flex items-center"
          >
            <FaChevronLeft className="mr-1" /> Back to Home
          </Link>

          <div className="flex items-center mb-4">
            <FaGlobeAmericas className="text-yellow-500 mr-2 text-xl" />
            <h2 className="text-3xl font-bold text-yellow-600">
              Terms of Engagement
            </h2>
          </div>

          <div className="space-y-6">
            <div className="border-l-4 border-yellow-500 pl-4">
              <h3 className="text-xl font-semibold">The Agreement</h3>
              <p>
                As you read these terms, you'll notice how they're designed to{" "}
                <span className="font-bold text-yellow-600">
                  protect your interests
                </span>{" "}
                while connecting you with life-changing opportunities. By
                proceeding, you're telling yourself "I'm ready for international
                success."
              </p>
            </div>

            <div className="border-l-4 border-yellow-500 pl-4">
              <h3 className="text-xl font-semibold">Our Commitment</h3>
              <p>
                We provide{" "}
                <span className="font-bold text-yellow-600">
                  exclusive access
                </span>{" "}
                to premium venues worldwide. Notice how this feels different
                from ordinary agencies - we're your gateway to the elite global
                entertainment industry.
              </p>
            </div>

            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <p className="italic">
                "When you imagine signing with us, can you feel the excitement
                building? That's your subconscious recognizing a rare
                opportunity for transformation."
              </p>
            </div>

            <div className="text-center mt-8">
              <Link
                to="/#apply"
                className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-8 rounded-lg transition"
              >
                Begin Your Journey Now
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
